import { SubscriptionName } from '@anm/api/modules/subscription';
import { UpgradeSubscriptionFormFields } from '@anm/components/subscription/UpgradeSubscriptionForm';
import findSubscription from '@anm/helpers/subscription/findSubscription';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useSubscriptionList from '../../../../hooks/subscription/useSubscriptionList';
import { subscriptionActions, subscriptionSelectors } from '../../../../store/modules/subscription';

const usePurchaseHandler = (subscriptionName: SubscriptionName) => {
  const dispatch = useDispatch();
  const isSubscriptionChangePending = useSelector(subscriptionSelectors.selectSubscriptionChangePending);
  const subscriptions = useSelector(subscriptionSelectors.selectSubscriptionList);
  useSubscriptionList();

  const handlerPurchase = useCallback(
    ({ email, coupon, billingPeriod, expiry_month, expiry_year, ...otherProps }: UpgradeSubscriptionFormFields) => {
      dispatch(
        subscriptionActions.changeSubscription({
          email,
          name: (subscriptions && findSubscription(subscriptions)(subscriptionName)?.name) || subscriptionName,
          period: billingPeriod,
          couponCode: coupon,
          stripe: {
            ...otherProps,
            exp_month: expiry_month,
            exp_year: expiry_year
          }
        })
      );
    },
    []
  );

  return [handlerPurchase, isSubscriptionChangePending] as const;
};

export default usePurchaseHandler;
